export default {
  our_team_title: {
    en: 'Our Team',
    fr: 'Notre équipe',
  },
  our_members_title: {
    en: 'Our Members',
    fr: 'Nos membres',
  },
  team_captain_title: {
    en: 'Captaincy',
    fr: 'Capitainerie',
  },
  team_captain_description: {
    en: 'Leadership team of the club',
    fr: 'Équipe de direction du club',
  },
  team_administration_title: {
    en: 'Administration',
    fr: 'Administration',
  },
  team_administration_description: {
    en: 'Administrative team of the club',
    fr: 'Équipe administrative du club',
  },
  team_electrical: {
    en: 'Electrical',
    fr: 'Électrique',
  },
  team_mechanical: {
    en: 'Mechanical',
    fr: 'Mécanique',
  },
  team_member: {
    en: 'Member',
    fr: 'Membre',
  },
  team_software: {
    en: 'Software',
    fr: 'Logiciel',
  },
  team_maintenance_title: {
    en: 'Maintenance',
    fr: 'Maintenance',
  },
  team_maintenance_description: {
    en: 'Robot maintenance team',
    fr: 'Équipe de maintenance des robots',
  },
  team_other_projects_title: {
    en: 'Other projects',
    fr: 'Autres projets',
  },
  team_other_projects_description: {
    en: 'Other projects of the club',
    fr: 'Autres projets du club',
  },
};
